export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;


type TCurrentEnv = 'trustus' | 'synvest';

export const currentEnv: TCurrentEnv = import.meta.env.VITE_ENV;

export const dynIBAN = currentEnv === 'trustus' ? 'NL79ABNA0105665118' : 'NL02ABNA0605822948';

export const dynBankAccountName = currentEnv === 'trustus' ? 'Stichting Administratiekantoor Trustus Beleggingsfondsen' : 'Stichting Administratiekantoor SynVest Beleggingsfondsen';